"use client";

import { useTranslations } from "next-intl";

import { Title } from "@/shared/components/title";
import { tp } from "@/shared/utils/typograf";
import { Subtitle } from "@/shared/components/subtitle";
import { ReactNode } from "react";
import Image from "next/image";

import BrandTelegramIcon from "@/shared/icons/brand-telegram.svg";
import DeviceMobileIcon from "@/shared/icons/device-mobile.svg";
import FinzyBrandIcon from "@/shared/icons/finzy-brand.svg";
import PercentageIcon from "@/shared/icons/percentage.svg";
import ClockHour5Icon from "@/shared/icons/clock-hour-5.svg";
import EmailIcon from "@/shared/icons/email.svg";

export interface NoCommissionItemProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
}

export const NoCommissionItem = (props: NoCommissionItemProps) => (
  <div className="flex items-start gap-4">
    <div className="flex items-center justify-center size-10 rounded-full bg-[#2A2A2A] shrink-0">
      {props.icon}
    </div>
    <div className="lg:max-w-82.5 space-y-1">
      <h5 className="text-xl leading-7 lg:text-2xl lg:leading-8 font-medium">
        {props.title}
      </h5>
      <p className="text-[#7B7B87] text-base leading-6 lg:text-xl lg:leading-7">
        {props.subtitle}
      </p>
    </div>
  </div>
);

export const NoCommission = () => {
  const t = useTranslations("noCommission");

  return (
    <div
      id="transfers"
      className="no-commission-container scroll-mt-20 lg:scroll-mt-28"
    >
      <div className="section-container">
        <div className="relative z-20 space-y-8 lg:space-y-13.5">
          <div className="space-y-4 text-center">
            <Title>{tp.execute(t("title"))}</Title>
            <Subtitle>{tp.execute(t("subtitle"))}</Subtitle>
          </div>
          {/* На мобильном превью идёт первым, за ним обе колонки пунктов подряд. */}
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-4">
            <div className="order-2 lg:order-none lg:max-w-96 space-y-8 lg:shrink-0">
              <NoCommissionItem
                icon={<BrandTelegramIcon className="size-6.5" />}
                title={tp.execute(t("items.telegram.title"))}
                subtitle={tp.execute(t("items.telegram.subtitle"))}
              />
              <NoCommissionItem
                icon={<EmailIcon className="size-6.5" />}
                title={tp.execute(t("items.email.title"))}
                subtitle={tp.execute(t("items.email.subtitle"))}
              />
              <NoCommissionItem
                icon={<DeviceMobileIcon className="size-6.5" />}
                title={tp.execute(t("items.phone.title"))}
                subtitle={tp.execute(t("items.phone.subtitle"))}
              />
            </div>
            <div className="order-1 lg:order-none w-full">
              <Image
                src="/images/no-commission-iphone.png"
                width={341}
                height={440}
                alt="Easy To Use Background"
                className="mx-auto max-w-56 lg:max-w-full"
              />
            </div>
            <div className="order-3 lg:order-none lg:max-w-96 lg:shrink-0">
              <div className="space-y-8 lg:pl-10">
                <NoCommissionItem
                  icon={<FinzyBrandIcon className="size-6.5" />}
                  title={tp.execute(t("items.betweenUsers.title"))}
                  subtitle={tp.execute(t("items.betweenUsers.subtitle"))}
                />
                <NoCommissionItem
                  icon={<PercentageIcon className="size-6.5" />}
                  title={tp.execute(t("items.noCommission.title"))}
                  subtitle={tp.execute(t("items.noCommission.subtitle"))}
                />
                <NoCommissionItem
                  icon={<ClockHour5Icon className="size-6.5" />}
                  title={tp.execute(t("items.access247.title"))}
                  subtitle={tp.execute(t("items.access247.subtitle"))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="no-commission-background">
        <Image
          src="/images/easy_to_use-background.png"
          width={1263}
          height={842}
          alt="Easy To Use Background"
          className="no-commission-image"
          quality={100}
        />
      </div>
    </div>
  );
};
